<template>
    <v-card flat>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>

        <template v-else>
            <v-container>
                <v-card-title>{{ client.name }}</v-card-title>
                <v-card-subtitle class="pb-0">{{ client.cpfcnpj }}</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="client.primaryEmail"
                                :label="$t('client.info.primaryEmail')"
                                flat
                                readonly
                                disabled
                                hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="client.commercialPhone"
                                :label="$t('client.info.commercialPhone')"
                                v-mask="['(##) ####-####', '(##) #####-####']"
                                flat
                                readonly
                                disabled
                                hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="client.cellPhone"
                                :label="$t('client.info.cellPhone')"
                                v-mask="['(##) ####-####', '(##) #####-####']"
                                flat
                                readonly
                                disabled
                                hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-switch
                                v-model="client.isActive"
                                :label="`${$t(`client.info.isActive.${$route.meta.singleName.toLowerCase()}`)} (${client.isActive ? $t('common.yes') : $t('common.no')})`"
                                flat
                                inset
                                readonly
                            ></v-switch>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                v-model="client.comments"
                                :label="$t('client.info.comments')"
                                flat
                                readonly
                                disabled
                                hide-details
                                no-resize
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-subheader class="pa-0 font-weight-bold">Contatos do Cliente</v-subheader>
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                    <template v-if="client.contacts">
                        <v-row v-for="(contact, index) in client.contacts" :key="index">
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="client.contacts[index].name"
                                    label="Nome"
                                    flat
                                    readonly
                                    disabled
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="client.contacts[index].email"
                                    label="Email"
                                    flat
                                    readonly
                                    disabled
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="client.contacts[index].phone"
                                    label="Telefone"
                                    v-mask="['(##) ####-####', '(##) #####-####']"
                                    flat
                                    readonly
                                    disabled
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="client.contacts[index].jobtitle"
                                    label="Cargo"
                                    flat
                                    readonly
                                    disabled
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
            </v-container>
        </template>
    </v-card>
</template>

<script>
import API from '@/api'
import { mask } from 'vue-the-mask'

export default {
    name: 'detail-tab-user',
    directives: {
        mask
    },
    data: function () {
        return {
            loading: true,
            mask: {
                cep: '##.###-###'
            },
            collapse: undefined,
            client: {}
        }
    },
    watch: {
        '$route': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.loadData()
    },
    computed: {
        birthdayFoundationDateFormated () {
            return this.birthdayFoundationDateNormalize()
        }
    },
    methods: {
        loadData () {
            this.loading = true
            window.getApp.disableClientNavigation = true
            let endpoint = API.EndPoints.getClient
            let params = {
                objectId: this.$route.params.id
            }
            new API(endpoint, params).request().then(response => {
                this.client = Object.assign({}, response.data.result)
                this.loading = false
                window.getApp.disableClientNavigation = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        birthdayFoundationDateNormalize () {
            return this.$options.filters.momentFormatDate(this.client.birthdayFoundationDate, 'L')
        }
    }
}
</script>
